export default "__VITE_ASSET__51347625__"